import { Component, Inject, OnInit } from '@angular/core';
import { EnergyDataService } from './_shared/services/energy-data.service';
import { MonitoringService } from './_shared/services/monitoring.service';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    constructor(
        private energyDataService: EnergyDataService,
        private monitoringService: MonitoringService) {
    }

    ngOnInit(): void {
        console.log("App OnInit");
        // When MSAL requests a token silently, the application is opened in an iFrame and the response (with token) is intercepted. The page in the iFrame itself is not used so prevent loading data.
        const isInIFrame = (window.parent !== window)
        if (!isInIFrame) {
            this.energyDataService.load();
        }
        else {
            console.log("App loaded in iFrame so not loading data");
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/app.component.ts